var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddBottleBlueFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 116.31 116.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e5e5e5;}.cls-2{fill:#101e33;stroke:#f1ab50;}.cls-2,.cls-4{stroke-miterlimit:10;stroke-width:2px;}.cls-3,.cls-4{fill:#f3f5eb;}.cls-4{stroke:#101e33;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 26.97,
    cy: 42.03,
    r: 2.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 26.97,
    cy: 49.25,
    r: 2.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 58.16,
    cy: 58.16,
    r: 57.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.56,92.93s13.26,1.5,12.66-6.1l.5-36.45s0-5.29-5.82-8.89c0,0-2.41-1.1-1.81-7.29l-.3-10,.5-1.2-.4-2.09-.61-1.4H47.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.32,92.93s-13.26,1.5-12.66-6.1l-.5-36.45s0-5.29,5.82-8.89c0,0,2.42-1.1,1.81-7.29l.3-10-.5-1.2.4-2.09.61-1.4h8.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 58.16,
    y: 57.7,
    width: 37.98,
    height: 8.8,
    rx: 0.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 58.16,
    y: 58.14,
    width: 37.98,
    height: 7.93,
    rx: 0.74,
    transform: "translate(15.04 139.25) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBottleBlueFilled);
export default __webpack_public_path__ + "static/media/add_bottle_blue_filled.cf4a257ee36cffdd67501d0ec96a2285.svg";
export { ForwardRef as ReactComponent };